export enum SiteLangs {
  EN = 'en',
  ES = 'es',
  ZH = 'zh',
  PT = 'pt'
}